module.exports = __webpack_public_path__ + "static/media/NEWNEWS.9cd64a4a.png";